// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "lbh3-snooze-button {\n  display: flex;\n}\nlbh3-snooze-button label {\n  cursor: pointer;\n}\n", "",{"version":3,"sources":["webpack://./components/snooze-button/snooze-button.less"],"names":[],"mappings":"AAAA;EACC,aAAA;AACD;AAFA;EAIE,eAAA;AACF","sourcesContent":["lbh3-snooze-button {\n\tdisplay: flex;\n\n\tlabel {\n\t\tcursor: pointer;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
